import { Link } from 'gatsby'
import React from 'react'
import { ButtonFooter } from 'components/atoms/button_footer'
import GiftBoxIcon from 'images/icon-giftbox-blue.svg'
import type { ButtonProps } from '@mui/material'

type Props = Pick<ButtonProps, 'sx'>

export const ContentPartnerContactButton: React.FC<Props> = ({ sx }) => (
  <ButtonFooter
    color="marine"
    to="/inquiry_contents_partner/"
    component={Link}
    icon={GiftBoxIcon}
    label="ギフト掲載のお問合せはこちら"
    sx={{
      ...sx,
    }}
  />
)
